import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=45052996"
import script from "./Subheader.vue?vue&type=script&lang=js"
export * from "./Subheader.vue?vue&type=script&lang=js"
import style0 from "./Subheader.vue?vue&type=style&index=0&id=45052996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports